// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3JZBp","obliqueLineWrap":"membershipbadge_obliqueLineWrap__OZrOd","obliqueLine":"membershipbadge_obliqueLine__1Y3nB"};